var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-section"},[_c('div',[_c('div',{staticClass:"setting-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"setting-description"},[_vm._t("description")],2)]),_c('div',{staticClass:"pl-3"},[(_vm.isLoading)?_c('AppLoader',{attrs:{"size":"20px"}}):_vm._t("trigger")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }